import { generatePath } from 'react-router';
import { takeLatest, select, call, put, all } from 'redux-saga/effects';

import { SELECT_DEALER } from 'constants/ActionTypes';
import { SEARCH_PROXY } from 'constants/ApiConstants';
import { PATH } from 'constants/RoutesConstants';
import { scopeToPage } from 'modules/app/sagas/utils';
import { SELECT_GROUP } from 'modules/groups/actionTypes';
import { navigate } from 'modules/router/navigate';
import { fetchTags } from 'modules/tags/actions';
import * as types from 'modules/tags/actionTypes';
import { DASHBOARD_DEALER_SOURCE, DASHBOARD_GROUP_SOURCE, DashboardTypeEnum } from 'modules/tags/constants';
import { getBaseRequestParams } from 'modules/tags/selectors/dashboard';

import { getTagModeFromRoute, isTagsDealerContext } from '../selectors/route';

const REFRESH_ACTIONS_TYPES = [
  SELECT_GROUP,
  SELECT_DEALER,
  types.SET_TAGS_DASHBOARD_FILTER,
  types.SET_TAGS_DASHBOARD_FILTERS,
  types.CLEAR_TAGS_DASHBOARD_FILTERS,
  types.REMOVE_TAGS_DASHBOARD_FILTER,
];

function* refreshDealerDashboard() {
  const mode = yield select(getTagModeFromRoute);
  const groupParams = yield select(state => getBaseRequestParams(state, DashboardTypeEnum.GROUP, mode));
  const dealerParams = yield select(state => getBaseRequestParams(state, DashboardTypeEnum.DEALER, mode));

  yield all([
    put(fetchTags({ ...groupParams, proxy: SEARCH_PROXY.ALTERABLE }, { source: DASHBOARD_GROUP_SOURCE })),
    put(fetchTags({ ...dealerParams, proxy: SEARCH_PROXY.ALTERABLE }, { source: DASHBOARD_DEALER_SOURCE })),
  ]);
}

function* refreshGroupDashboard() {
  const mode = yield select(getTagModeFromRoute);
  const groupParams = yield select(state => getBaseRequestParams(state, DashboardTypeEnum.GROUP, mode));
  yield put(fetchTags({ ...groupParams, proxy: SEARCH_PROXY.ALTERABLE }, { source: DASHBOARD_GROUP_SOURCE }));
}

function* onDuplicateSuccess({ payload }) {
  const { id: tagId, mode } = payload;
  const isDealer = yield select(isTagsDealerContext);

  // Build redirect path
  const pathTemplate = isDealer ? PATH.DEALER_TAGS_DETAILS.path : PATH.GROUP_TAGS_DETAILS.path;
  const detailsPath = generatePath(pathTemplate, { mode, tagId });

  // Redirect to details page
  yield call(navigate, detailsPath, { replace: true });
}

function* initializeDealerDashboard() {
  yield call(refreshDealerDashboard);
  yield takeLatest(REFRESH_ACTIONS_TYPES, refreshDealerDashboard);
}

function* initializeGroupDashboard() {
  yield call(refreshGroupDashboard);
  yield takeLatest(REFRESH_ACTIONS_TYPES, refreshGroupDashboard);
}

export default function* dashboardTagsSaga() {
  yield scopeToPage([PATH.GROUP_TAGS_DASHBOARD], initializeGroupDashboard);
  yield scopeToPage([PATH.DEALER_TAGS_DASHBOARD], initializeDealerDashboard);
  yield takeLatest(types.CLONE_TAG_SUCCESS, onDuplicateSuccess);
}
